import gql from 'graphql-tag';

export const addPlatebniPrikaz = gql`
  mutation addPlatebniPrikaz($input: [PlatebniPrikazInput!]!) {
    response: addPlatebniprikaz(inputPlatebniprikaz: $input) {
      id
    }
  }
`;
